<template>
  <ul class="tour-list relative flex flex-col items-center">
    <li
      v-for="item in tour.children"
      :key="item.slug"
      class="relative tour-stop lg:even:tour-stop--even lg:even:ml-84 lg:odd:tour-stop--odd lg:odd:mr-84 lg:even:-mt-20 mb-3 lg:mb-0"
    >
      <RouterLink
        :to="item.slug"
        append
        class="tour-stop--mob flex w-80vw md:w-50vw lg:flex-col lg:h-40 lg:w-56 bg-white lg:b-t-accent-1 focus-a shadow-xl"
      >
        <div
          v-if="item.guided_tour_thumbnail"
          role="img"
          alt="item.guided_tour_thumbnail.alt"
          class="h-12 w-18 flex-none lg:w-full lg:h-28 bg-full"
          :style="
            `background-image: url(${item.guided_tour_thumbnail.sizes.thumbnail})`
          "
        />
        <div class="flex-a h-12 p-2 text-secondary text-sm">
          <IconBase :icon="`${item.type}icon`" size="19px" class="mr-2" />
          {{ htmlDecode(item.title) }}
        </div>
      </RouterLink>
    </li>
  </ul>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import IconBase from '@/components/icons/IconBase.vue'

export default {
  name: 'TourStops',

  components: {
    IconBase
  },

  props: {
    tour: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    ...mapState(['touch', 'mobile']),
    ...mapGetters([])
  }
}
</script>
